import * as firebase from 'firebase'
import { Store } from 'vuex';

export default {
  state: {
    play: null,
    colour: null,
    cameras:null,
    cameraOptions:{duration:5,showDetails:true,zoom:true},
    pixels:[],
    pixelIndex:0
   
  },
  mutations: {
    setPixel(state,payload){

    },
    setPixelIndex(state,payload){
      console.log("payload",payload)
      state.pixelIndex=payload
    },
    setCameraOptions(state,payload){
      state.cameraOptions=payload
    },
    setCameras(state,payload){
      console.log("Active Cameras",payload)
      state.cameras=payload
    },
    setPixels(state,payload){
      state.pixels=payload
    },
    setPlay(state, payload) {
      state.play = payload
    },
    setColour(state, payload) {
      console.log("SET COLOUR", payload)
      state.colour = payload
    },
  },
  actions: {
    loadCameras({ commit }) {
      console.log("LOAD CAMERAS",)
      commit('setLoading', true)
      firebase
        .database()
        .ref('play/webcams')
        .once('value')
        .then(data => {
          console.log("CAMERA",data.val())
          let cams=data.val()
          let cam
          let activeCams=[]
          for (var c in cams){
            cam=cams[c]
            if(c=="options"){
              commit('setCameraOptions',cam)
            }else{
              if(cam.active){
                activeCams.push(cam)
              }
              
              console.log(cam.name,cam.active)
            }
          }
          commit('setCameras',activeCams)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    loadPlay({ commit }) {
      firebase
        .database()
        .ref('play')
        .on('value', function(snapshot) {
          commit('setPlay', snapshot.val())
        });
    },
    addPixel({ commit }) {
      firebase
        .database()
        .ref('play/pixel/pixelIndex')
        .once('value').then(data => {
          commit('setPixelIndex', data.val())
          firebase.database().ref('play/pixel/') .update({ pixelIndex: data.val()+1 })
          firebase
        .database()
        .ref('play/pixel/pixels')
        .child('pixel'+data.val())
        .update({ xpos: 0,ypos:0 ,color:"rgb(255,255,255"})

        })
    },
    loadPixels({ commit }) {
      firebase
        .database()
        .ref('play/pixel/pixels')
        .on('value', function(snapshot) {
          commit('setPixels', snapshot.val())
        })
      
    },
    resetPixels({ commit }){
      firebase.database().ref('play/pixel/').update({ pixelIndex: 0 })
      firebase.database().ref('play/pixel/').update({ pixels: [] })
    },
    loadColour({ commit }) {
      firebase
        .database()
        .ref('play/colour')
        .on('value', function(snapshot) {
          commit('setColour', snapshot.val())
          
        })
    },
    setColour({ commit }, payload) {
      console.log("SET COLOUR XX", payload)
      var value = payload;
      firebase
        .database()
        .ref('play')
        .update({ colour: value })
        .then(() => {
          commit('setColour', value)
        })
    },
    setPixel({ commit }, payload) {
      var value = payload.xpos;
      console.log("SET pos", payload,value)
      firebase
        .database()
        .ref('play/pixel/pixels')
        .child(payload.id)
        .update({ xpos: payload.xpos,ypos:payload.ypos,color:payload.color })
        .then(() => {
          commit('setPixel', payload)
        })
    },
  },
  getters: {
    getPixelIndex(state){
      return state.pixelIndex
    },
    getCameraOptions(state){
      return state.cameraOptions
    },
    getCameras(state){
      return state.cameras
    },
    getPlay(state) {
      return state.play
    },
    getColour(state) {
      return state.colour;
    },
    getPixels(state) {
      return state.pixels;
    },

  }
}


// WEBPACK FOOTER //
// ./src/store/play/index.js